<template>
  <div class="bank">
    <div :class="isShowMe?'orderDetails':'orderDetails hide'">
      <div :class="isShowMe?'detailList-bg':'detailList-bg hide'"></div>
      <div class="detailList">
        <div class="dl-top">
          <div class="dl-title fl">添加银行卡</div>
          <div class="dl-close fr"><img @click="closeWindow" src="../assets/close.png" ></div>
        </div>
         <div class="main">
           <el-row :gutter="5" align="middle" type="flex" class="mtb40"> 
            <el-col :span="4"><div class="grid-content bg-purple tar">账户名称：</div></el-col>
            <el-col :span="9"><div class="grid-content bg-purple">
              
            <el-select v-model="bankId" size="medium" placeholder="请选择提现账户">
                <el-option
                v-for="item in bankTypes"
                :key="item.Kind"
                :label="item.Value"
                :value="item.Kind">
                </el-option>
            </el-select>
              
            </div></el-col>
            <el-col :span="11"><div class="grid-content bg-purple red ml20">仅支持可选择的银行卡提现</div></el-col>
          </el-row>
          <el-row :gutter="5" align="middle" type="flex" class="mtb30"> 
            <el-col :span="4"><div class="grid-content bg-purple tar">开户人姓名：</div></el-col>
            <el-col :span="9"><div class="grid-content bg-purple"><el-input size="medium" placeholder="请输入开户人姓名"  v-model="name"></el-input>
            </div></el-col>
            <el-col :span="11"><div class="grid-content bg-purple red ml20" v-show="bankId==10">已实名认证的支付宝才可收款</div></el-col>
          </el-row>
          <el-row :gutter="5" align="middle" type="flex" class="mtb30"> 
            <el-col :span="4"><div class="grid-content bg-purple tar">确认户名：</div></el-col>
            <el-col :span="9"><div class="grid-content bg-purple"><el-input size="medium" placeholder="请输入确认户名"  v-model="confirmName"></el-input>
            </div></el-col>
            <el-col :span="11"><div class="grid-content bg-purple"></div></el-col>
          </el-row>
          <el-row :gutter="5" align="middle" type="flex" class="mtb30"> 
            <el-col :span="4"><div class="grid-content bg-purple tar">账号：</div></el-col>
            <el-col :span="9"><div class="grid-content bg-purple"><el-input size="medium" placeholder="请输入账号"  v-model="account"></el-input>
            </div></el-col>
            <el-col :span="11"><div class="grid-content bg-purple red ml20">请仔细核对卡号，如填写有误无法提现</div></el-col>
          </el-row>
          <el-row :gutter="5" align="middle" type="flex" class="mtb30"> 
            <el-col :span="4"><div class="grid-content bg-purple tar">确认账号：</div></el-col>
            <el-col :span="9"><div class="grid-content bg-purple"><el-input size="medium" placeholder="请输入确认账号"  v-model="confirmAccount"></el-input>
            </div></el-col>
            <el-col :span="11"><div class="grid-content bg-purple"></div></el-col>
          </el-row>
         </div>

          <div class="dl-footer">
             <el-row  align="middle"  type="flex" class="mb20"> 
              <el-col :span="19"><div class="grid-content bg-purple"></div></el-col>
              <el-col :span="5">
                <div class="grid-content bg-purple">
                  <el-button type="primary" size="small" @click="closeWindow">取消</el-button>
                  <el-button type="primary" size="small" v-if="ID==0" @click="bindBank">添加</el-button>
                  <el-button type="primary" size="small" v-else @click="editBank">修改</el-button>
                </div>
              </el-col>
            </el-row>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'bank',
  props:{
    isShow:Boolean,
    ID:Number
  },
  data () {
    return {
       isShowMe:this.isShow,
       bankTypes: [],
       name:'',
       confirmName:'',
       account:'',
       confirmAccount:'',
       bankId:10
    }
  },
  computed:{
    
  },
  methods: {
    closeWindow(){
			this.isShowMe=false;
    },
    bankTypeList(){
      const self=this;
      var data= this.common.GetlocalStorage("UnLockUserData");
      var obj=JSON.parse(data);
      var userId=obj.UserID;
      self.http.ajaxGet("BankTypeList?UserID="+userId,function(res){
          self.bankTypes=res.Result;
        },function(err){
          self.$alert(err, '错误', {confirmButtonText: '确定'});
      })
    },
    bindBank(){
      const self=this;
      if(self.name=="")
        this.$message({ message: '请输入开户人姓名', type: 'warning'});
      else if(self.confirmName=="")
        this.$message({ message: '请输入确认户名', type: 'warning'});
      else if(self.account=="")
        this.$message({ message: '请输入账号', type: 'warning'});
      else if(self.confirmAccount=="")
        this.$message({ message: '请输入确认账号', type: 'warning'});
      else if(self.name!=self.confirmName)
        this.$message({ message: '开户人姓名和确认户名不一致', type: 'warning'});
      else if(self.account!=self.confirmAccount)
        this.$message({ message: '账号和确认账号不一致', type: 'warning'}); 
      else{
        var data= this.common.GetlocalStorage("UnLockUserData");
        var obj=JSON.parse(data);
        var userId=obj.UserID;
        self.http.ajaxGet("BindBank?UserID="+userId+"&BankId="+self.bankId+"&BankUser="+self.name+"&BankAcc="+self.account,function(res){
            if(res.ReturnCode == 1){
              self.$emit("on-success",self.bankId);
              self.closeWindow();
              self.$alert(res.Message, '温馨提示', {confirmButtonText: '确定'});
            }else{
              self.$alert(res.Message, '温馨提示', {confirmButtonText: '确定'});
            }
          },function(err){
            self.$alert(err, '错误', {confirmButtonText: '确定'});
        })
      }
    },
    editBank(){
      const self=this;
      if(self.name=="")
        this.$message({ message: '请输入开户人姓名', type: 'warning'});
      else if(self.confirmName=="")
        this.$message({ message: '请输入确认户名', type: 'warning'});
      else if(self.account=="")
        this.$message({ message: '请输入账号', type: 'warning'});
      else if(self.confirmAccount=="")
        this.$message({ message: '请输入确认账号', type: 'warning'});
      else if(self.name!=self.confirmName)
        this.$message({ message: '开户人姓名和确认户名不一致', type: 'warning'});
      else if(self.account!=self.confirmAccount)
        this.$message({ message: '账号和确认账号不一致', type: 'warning'}); 
      else{
        var data= this.common.GetlocalStorage("UnLockUserData");
        var obj=JSON.parse(data);
        var userId=obj.UserID;
        self.http.ajaxGet("UpdateBank?ID="+self.ID+"&UserID="+userId+"&BankId="+self.bankId+"&BankUser="+self.name+"&BankAcc="+self.account,function(res){
            if(res.ReturnCode == 1){
              self.$emit("on-success",self.bankId);
              self.closeWindow();
              self.$alert(res.Message, '温馨提示', {confirmButtonText: '确定'});
            }else{
              self.$alert(res.Message, '温馨提示', {confirmButtonText: '确定'});
            }
          },function(err){
            self.$alert(err, '错误', {confirmButtonText: '确定'});
        })
      }
    },
    bankList(){
      const self=this;
      var data= this.common.GetlocalStorage("UnLockUserData");
      var obj=JSON.parse(data);
      var userId=obj.UserID;
      self.http.ajaxGet("BankList?UserID="+userId,function(res){
          self.bankId=res.Result[0].BankID;
          self.name=res.Result[0].BankUser;
          self.confirmName=res.Result[0].BankUser;
          self.account=res.Result[0].BankAcc;
          self.confirmAccount=res.Result[0].BankAcc;
        },function(err){
          self.$alert(err, '错误', {confirmButtonText: '确定'});
      })
    },
  },
  watch: {
    isShow(val) {
      this.isShowMe = val;
    },
    isShowMe(val){
      if(val){
        if(this.ID>0)
          this.bankList();
      }else{
        this.$emit("on-close",val);
      }
    }
  },
  mounted: function () {
    this.bankTypeList();    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .detailList-bg{position:fixed;width:100%;height:100%;bottom:0;left:0; background:#000;filter:alpha(opacity=50); -moz-opacity:0.5; opacity: 0.5; margin:0; padding:0; z-index:99; }
	.detailList{width:770px;height:470px;position: fixed; top:50%; left:50%; margin-left:-385px; margin-top:-235px;  z-index:999; background: #fff; }
	.detailList .dl-top{background: #f0f0f0; height:60px; line-height: 60px;}
	.detailList .dl-title{ font-size:20px; color:#444; margin-left:45px;}
	.detailList .dl-close{ margin-right:25px; margin-top:8px;}
	.detailList .dl-close img{ cursor: pointer;}
  .detailList .dl-footer{height:60px; line-height:60px; font-size:16px; color:#444; background: #eee; position:absolute; bottom:0; width:710px; padding:0 30px;}
  .detailList .main{ padding:0 30px; font-size:16px; color:#444;}
  .mb20{margin-bottom:20px;}
  .bank .red{ color:#ff5151;}
  .bank .mtb30{ margin:20px 0;}
  .bank .mtb40{ margin:40px 0 20px;}
  .bank .ml20{padding-left:20px;}
  .bank .tar{ text-align: right;}
</style>



// WEBPACK FOOTER //
// src/components/bank.vue